import { PenggunaModel } from './../../_model/auth/authentication.model';
import { AuthenticationService } from './../../_services/auth/authentication.service';
import { DatatablesModelResponse } from './../../_model/utils/datatables.model';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from "@angular/common/http";
import { SkpdBasModel, SkpdModel, SkpdPersetujuanModel } from "./skpd.model";
import { environment } from "../../../environments/environment";
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class SkpdService {
  skpdId: string;
  currentOtor: string;
  tahunAnggaran: any = localStorage.getItem('defaultYear')?.replace(/\D/g, '');

  constructor(
    private httpClient: HttpClient,
    private _authService: AuthenticationService,
    private router: Router
  ) {
    this.tahunAnggaran = localStorage.getItem('defaultYear')?.replace(/\D/g, '');
    let pengguna: PenggunaModel = _authService.currentUserDetail;
    this.skpdId = JSON.parse(localStorage.getItem('skpdDetail')).id;
    this.currentOtor = pengguna.otor;
  }

  getCurrentSkpd(): SkpdModel {
    let skpd: SkpdModel = JSON.parse(localStorage.getItem('skpdDetail'));
    return skpd;
  }

  setCurrentSkpd(idSkpd: string) {
    this.getSkpd(idSkpd).subscribe(response => {
      localStorage.removeItem('skpdDetail');
      localStorage.setItem('skpdDetail', JSON.stringify(response));
    })
  }

  listSkpd() {
    return this.httpClient.get<SkpdModel[]>(`${environment.uriApi}/api/skpd/list`);
  }

  listSkpdPersetujuan() {
    let params = new HttpParams();
    params = params.append('tahunAnggaran', localStorage.getItem('defaultYear')?.replace(/\D/g, ''));
    return this.httpClient.get<SkpdPersetujuanModel[]>(`${environment.uriApi}/api/skpd/listNew`, { params: params });
  }

  getSkpd(id: string) {
    return this.httpClient.get<SkpdModel>(`${environment.uriApi}/api/skpd/${id}`);
  }
  public getSkpdDatatables(parameters: any, value: SkpdModel) {
    let params = new HttpParams();
    params = params.append('start', parameters.start);
    params = params.append('length', parameters.length);
    params = params.append('draw', parameters.draw);
    params = params.append('order[0][column]', parameters.order[0]['column']);
    params = params.append('order[0][dir]', parameters.order[0]['dir']);

    if (parameters.search && parameters.search.value) {
      params = params.append('search[value]', parameters.search.value);
    }

    return this.httpClient.post<DatatablesModelResponse>(
      `${environment.uriApi}/api/skpd/datatables`,
      value,
      { params: params }
    );
  }

  // SKPD BAS
  public datatablesPembiayaan(parameters: any, value: SkpdBasModel) {
    let params = new HttpParams();
    params = params.append('start', parameters.start);
    params = params.append('length', parameters.length);
    params = params.append('draw', parameters.draw);
    params = params.append('order[0][column]', parameters.order[0]['column']);
    params = params.append('order[0][dir]', parameters.order[0]['dir']);
    return this.httpClient.post<DatatablesModelResponse>(`${environment.uriApi}/api/skpd-bas/datatables-pembiayaan`, value, { params: params });
  }

  getfindSKPDBASSkpd(idBas: number, idSkpd: number) {
    let params = new HttpParams();
    params = params.append('idBas', String(idBas));
    params = params.append('idSkpd', String(idSkpd));
    return this.httpClient.get<SkpdBasModel>(`${environment.uriApi}/api/skpd-bas/find-skpd-bas`, { params: params });
  }

  getTotalAnggaranSpb(kodeOpd: string = '') {
    let params = new HttpParams().set('kodeOpd', kodeOpd);
    return this.httpClient.get<any>(`${environment.uriApi}/api/total-anggaran-tapd/spb/${this.tahunAnggaran}`, { params });
  }

  getTotalAnggaranERba(idSkpd: number = null) {
    let params = new HttpParams();
    if (idSkpd !== null) {
      params = params.set('idSkpd', idSkpd.toString());
    }
    return this.httpClient.get<any>(`${environment.uriApi}/api/total-anggaran-tapd/erba/${this.tahunAnggaran}`, { params });
  }

  getTotalAnggaranSelisih(kodeOpd: string = '', idSkpd: number = null) {
    let params = new HttpParams();
    params = params.append('kodeOpd', kodeOpd);
    if (idSkpd !== null) {
      params = params.append('idSkpd', idSkpd.toString());
    }
    return this.httpClient.get<any>(`${environment.uriApi}/api/total-anggaran-tapd/selisih/${this.tahunAnggaran}`, { params: params });
  }
}